import store from '@/store/'

import {apiAccountLogin,apiAccountMe} from "@/utils/api/apiAuth.js";

export default function auth ({ next, store }){
    console.log('ERRRRR');
    let accessToken = localStorage.getItem('accessToken');

    let accountData = localStorage.getItem('accountData');
    if(typeof(accountData)!='undefined'){
        accountData = JSON.parse(accountData);
    }
    //如果有設定accessToken則設定參數狀態為登入，遠端驗證稍後再做
    if(accessToken!=null){
        store.commit('auth/setAccessToken',accessToken);
        store.commit('auth/setLogin',true);
        store.commit('auth/setLoginAccount',accountData);
    }

    if(store.state.auth.isLogin == false){
        console.log('false');
        return next({
            name : 'login'
        });
    }

    //向遠端確認狀態
    let bridge = this;
    apiAccountMe().then(function(res){
        //完成將資料寫入store
        store.commit('auth/setLoginAccount',res.data.data);
        localStorage.setItem('accountData',JSON.stringify(res.data.data));

        return next();
    }).catch(error=>{
        store.commit('auth/setLogin',false);
        store.commit('auth/setAccessToken',null);

        return next({
            name : 'login'
        });
    });

}